import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FirstNg from './../block/FirstNg'
import NewNg from './../block/NewNg'
import CatalogNg from './../block/CatalogNg'
import CollectionsNg from './../block/CollectionsNg'
import RecomendedNg from './../block/RecomendedNg'
import FeedbackNg from './../block/FeedbackNg'
import AboutNg from './../block/AboutNg'
import ShopsNg from './../block/ShopsNg'
import QwestionsNg from './../block/QwestionsNg'

export default class Main extends Component {

  render() {

    const { ajax_data, page_data, catalogmenu, search, changeSearch, changeTopSearch, changeLeftMenuh, showInCart, in_cart_loading, favorite, changeFavorite, cart } = this.props

    return (
      <>
        <FirstNg
          ajax_data={ajax_data}
          page_data={page_data}
          changeTopSearch={changeTopSearch}
          changeLeftMenuh={changeLeftMenuh}
          favorite={favorite}
          cart={cart}
        />
        {/*
        <NewNg
          ajax_data={ajax_data}
          page_data={page_data}
        />
        */}
        <RecomendedNg
          title={`НОВЫЕ ПОСТУПЛЕНИЯ`}
          text={`Посмотрите наши последние поступления дизайнерской одежды и подберите свой стиль`}
          showInCart={showInCart}
          in_cart_loading={in_cart_loading}
          favorite={favorite}
          changeFavorite={changeFavorite}
          cart={cart}
          link={page_data.new_link}
          variant={`new`}
          start={ajax_data?.new_products || { page: 1, paginator: [], products: [] }}
        />
        <CatalogNg
          search={search}
          changeSearch={changeSearch}
          changeTopSearch={changeTopSearch}
          ajax_data={ajax_data}
          page_data={page_data}
          catalogmenu={catalogmenu}
        />
        <CollectionsNg
          ajax_data={ajax_data}
          page_data={page_data}
        />
        <RecomendedNg
          title={`РЕКОМЕНДАЦИИ ДЛЯ ВАС`}
          text={``}
          showInCart={showInCart}
          in_cart_loading={in_cart_loading}
          favorite={favorite}
          changeFavorite={changeFavorite}
          cart={cart}
          link={page_data.man_link}
          variant={`random`}
          start={{ page: 1, paginator: [], products: [] }}
        />
        <FeedbackNg
          ajax_data={ajax_data}
        />
        <AboutNg
          page_data={page_data}
        />
        <ShopsNg
          page_data={page_data}
          ajax_data={ajax_data}
        />
        <QwestionsNg
          ajax_data={ajax_data}
        />
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  catalogmenu: PropTypes.array,
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  showInCart: PropTypes.func,
  in_cart_loading: PropTypes.bool,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array
}